import { createI18n } from '@learnforge/i18n';
import type { DemoKey } from './types';
import { locales } from './locales';

export const i18n = createI18n<DemoKey>({
  gameId: 'statistics',
  locales,
});
